'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _events = require('events');

var _events2 = _interopRequireDefault(_events);

var _injectCompanionAd = require('./injectCompanionAd');

var _injectDynamicAdContent = require('./injectDynamicAdContent');

var _injectDynamicAdContent2 = _interopRequireDefault(_injectDynamicAdContent);

var _injectStaticAdContent = require('./injectStaticAdContent');

var _injectStaticAdContent2 = _interopRequireDefault(_injectStaticAdContent);

var _injectStaticInstreamAdContent = require('./injectStaticInstreamAdContent');

var _injectStaticInstreamAdContent2 = _interopRequireDefault(_injectStaticInstreamAdContent);

var _companionEvents = require('./companionEvents');

var _companionEvents2 = _interopRequireDefault(_companionEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getInstreamAdElement(slotElement, width, height, content) {
  if (content.staticResource) {
    return (0, _injectStaticInstreamAdContent2.default)(slotElement, content);
  }

  if (content.htmlResource) {
    return (0, _injectDynamicAdContent2.default)(slotElement, content.htmlResource, width, height);
  }

  return undefined;
}

function getDefaultAdElement(slotElement, width, height, content) {
  return (0, _injectCompanionAd.isDynamicAdContent)(content) ? (0, _injectDynamicAdContent2.default)(slotElement, content, width, height) : (0, _injectStaticAdContent2.default)(slotElement, content);
}

var CompanionAdManager = function (_EventEmitter) {
  _inherits(CompanionAdManager, _EventEmitter);

  function CompanionAdManager(companionCache) {
    _classCallCheck(this, CompanionAdManager);

    var _this = _possibleConstructorReturn(this, (CompanionAdManager.__proto__ || Object.getPrototypeOf(CompanionAdManager)).call(this));

    _this.companionCache = companionCache;
    return _this;
  }

  /**
   * Renders a companion ad using either an IFRAME, for dynamic ad content, or a DIV, for
   * static ad content. This method also renders a click handler on the IFRAME/DIV so
   * that click events can be published to listeners.
   *
   * @param slotElement {HTMLElement}: The element that is registered with the Mint Slot.
   * @param slot {MintSlot}: A model representing an HTMLElement where an ad can be inserted.
   * @param width {number}
   * @param height {number}
   * @param content {string}: The ad content for the companion ad.
   */


  _createClass(CompanionAdManager, [{
    key: 'renderCompanionAd',
    value: function renderCompanionAd(slotElement, slot, width, height, content) {
      var _this2 = this;

      try {
        var element = getInstreamAdElement(slotElement, width, height, content) || getDefaultAdElement(slotElement, width, height, content);

        if (!element) {
          this.emit(_companionEvents2.default.clickError, slot);
          return;
        }

        element.addEventListener('click', function () {
          return _this2.emit(_companionEvents2.default.clicked, slot);
        });
      } catch (ex) {
        this.emit(_companionEvents2.default.renderError, { slot: slot, error: ex });
      }
    }

    /**
     * Public method that finds associated display ad slots where a given companion ad
     * can be inserted. This discovery is performed by making use of the companionCache.
     * @param companionAds {array}: array of companion ads.
     * @param displaySlots {array}: array of MintDisplaySlots.
     * @param adSlotProvider {string}: the ad provider for the companion ads
     */

  }, {
    key: 'processCompanionAds',
    value: function processCompanionAds(companionAds, displaySlots, adSlotProvider) {
      var _this3 = this;

      this.companionCache.loadDisplaySlots(displaySlots);

      (0, _forEach2.default)(companionAds, function (ad) {
        var width = ad.width,
            height = ad.height,
            content = ad.content;

        var slot = _this3.companionCache.getCompanionSlot(width, height, adSlotProvider);

        if (slot) {
          // Remove the display slot from the cache so that it's
          // not refreshed.
          _this3.companionCache.removeDisplaySlot(width, height, adSlotProvider);
          _this3.emit(_companionEvents2.default.loaded, _extends({}, slot, { width: width, height: height, content: content }));
        }
      });

      // These are the display slot IDs that haven't been removed
      // from the companion cache that need to be refreshed.
      var slotIds = this.companionCache.displaySlotIds;
      (0, _forEach2.default)(slotIds, function (elementId) {
        _this3.emit(_companionEvents2.default.refreshDisplaySlot, elementId);
      });

      this.companionCache.reset();
    }
  }]);

  return CompanionAdManager;
}(_events2.default);

exports.default = CompanionAdManager;